export default "__VITE_ASSET__fpxZ6d0a__"